<template>
    <div>
        <el-dialog :visible.sync="visible" :close-on-click-modal="false" :before-close="close"  width="850px">
            <div slot="title">
                <z-title :title="typeName+'跟踪记录'"></z-title>
            </div>
            <div class="plr-20">
            <div class="flex-n fac ">
                <div class="mr-10">客户姓名：{{consultInfo.customName}}</div>
                <div class="mr-10">客户电话：{{consultInfo.phone}}</div>
                <div v-if="typeName=='咨询'">客户微信：{{consultInfo.wechatNo}}</div>
            </div>
            <el-table
                    class="mt-10"
                    header-cell-class-name="headerrow"
                    cell-class-name="cellclass"
                    :data="consultInfo.list"
                    style="width: 100%">
                <el-table-column
                        align="center"
                        prop="remark"
                        label="备注"
                        min-width="100">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="沟通日期"
                        min-width="120"
                        align="center">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        prop="createUserName"
                        label="经办人"
                        width="100"
                        align="center">
                </el-table-column>
            </el-table>
                <div class="flex-n fjc mt-10">
                <el-button type="primary" @click="close">关闭</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import ElDialog from "element-ui/packages/dialog/src/component";
    import ZTitle from "../../components/ZTitle";

    export default {
        components: {
            ZTitle,
            ElDialog},
        name: "processdetails",
        props:{
            visible:Boolean,
            id:String,
            typeName:{
                type:String,
                default:'咨询'
            },
            consultInfo:Object,
        },
        data(){
            return{
            }
        },
        mounted(){

        },
        methods:{
            close() {
                this.$emit('update:visible', false)
            },
        }
    }
</script>

<style scoped>

</style>